import { render, staticRenderFns } from "./DeliveryPop.vue?vue&type=template&id=33b83ef9&"
import script from "./DeliveryPop.vue?vue&type=script&lang=js&"
export * from "./DeliveryPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports